@if (tradableModel.hasDescription) {
  <span [ngClass]="{ 'compressed-font': !resetPriceStyle && buySellModal }">{{
    tradableModel.description
    | translate
    : [
    tradableModel.amount
    | tradable_precision_symbol
    : {
    id: tradableModel.id,
    addName: tradableModel.addName,
    noTrailingZeros: true,
    txPrecision: true
  }
  ]
}}</span>
} @else {
  <span [ngClass]="{ 'compressed-font': !resetPriceStyle && buySellModal }">{{
    tradableModel.amount
    | tradable_precision_symbol
    : {
    id: tradableModel.id,
    addName: tradableModel.addName,
    noTrailingZeros: true,
    txPrecision: true
  }
}}</span>
}
